/**
 * Utility helper to format phone numbers for WhatsApp API links (https://wa.me/...)
 */
export function formatWhatsAppPhone(phone) {
  if (!phone) return '';
  let cleaned = String(phone).replace(/\D/g, '');
  // Default to India country code 91 if 10-digit mobile number
  if (cleaned.length === 10) {
    cleaned = '91' + cleaned;
  }
  return cleaned;
}

export function buildWhatsAppLink(phone, message) {
  const formattedPhone = formatWhatsAppPhone(phone);
  if (!formattedPhone) return '#';
  const encodedText = encodeURIComponent(message || '');
  return `https://wa.me/${formattedPhone}${encodedText ? `?text=${encodedText}` : ''}`;
}
